import React, { useEffect, useState, useRef } from "react";

import { ConfigProvider } from "antd";
import { Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import { AppContext } from "./AppContext";
import LoggedIn from "./Containers/LoggedIn";
import LoggedOut from "./Containers/LoggedOut";

import {
  // handleLocalStorageChange,
  handlePageLoad, isUser, getUserCredentials, isThirdPartyUser,
} from "./utils/common";

import { axiosInterceptor } from "./actions/interceptor";

import { antdAppTheme } from "./styles/tokens";

import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min";
import "bootstrap/dist/js/bootstrap.min";

import "./App.css";

axiosInterceptor();

const App = ({ history }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(isUser());
  const [userTitle, setUserTitle] = useState(isUser() ? getUserCredentials().user_title : "");
  const [initialRoleCheckDone, setInitialRoleCheckDone] = useState(false);
  const appContext = { userTitle, setUserTitle, initialRoleCheckDone };
  const isLoggedInRef = useRef(isLoggedIn);
  const hasRunRoleCheckRef = useRef(false);

  // Keep ref in sync with state
  useEffect(() => {
    isLoggedInRef.current = isLoggedIn;
  }, [isLoggedIn]);

  /**
   * On App mount, add Storage Event and on load listeners.
   * Also listen for logout events to react to storage changes in same tab.
   */
  useEffect(() => {
    // Check login status and update state
    const checkLoginStatus = () => {
      const currentlyLoggedIn = isUser();
      if (currentlyLoggedIn !== isLoggedInRef.current) {
        setIsLoggedIn(currentlyLoggedIn);
        if (currentlyLoggedIn) {
          const credentials = getUserCredentials();
          setUserTitle(credentials?.user_title || "");
        } else {
          setUserTitle("");
        }
      }
    };

    // Initial check
    checkLoginStatus();

    /** Check for local storage changes to keep browsing contexts in sync */
    // const handleStorage = (e) => {
    //   handleLocalStorageChange(e, history, appContext);
    //   checkLoginStatus();
    // };
    // window.addEventListener("storage", handleStorage);

    /** Listen for custom logout event (same-tab logout) */
    const handleLogout = () => {
      checkLoginStatus();
    };
    window.addEventListener("userLoggedOut", handleLogout);

    /** Run role check once so we have final userTitle before LoggedIn fetches tabs */
    if (!hasRunRoleCheckRef.current) {
      hasRunRoleCheckRef.current = true;
      (async () => {
        if (!isUser()) {
          setInitialRoleCheckDone(true);
          return;
        }
        try {
          await handlePageLoad(appContext);
        } finally {
          setInitialRoleCheckDone(true);
        }
      })();
    }

    const handleLoad = () => {
      checkLoginStatus();
    };
    window.addEventListener("load", handleLoad);

    return () => {
      // window.removeEventListener("storage", handleStorage);
      window.removeEventListener("userLoggedOut", handleLogout);
      window.removeEventListener("load", handleLoad);
    };
  }, [history, appContext]); // eslint-disable-line

  return (
    <ConfigProvider theme={antdAppTheme}>
      <AppContext.Provider value={appContext}>
        <div className="App">
          <ToastContainer
            autoClose={3500}
            newestOnTop
            hideProgressBar={false}
            theme="colored"
            closeButton
            closeOnClick={false}
            pauseOnFocusLoss={false}
            draggable={false}
          />
          {isLoggedIn && !isThirdPartyUser() ? (
            <Route path="/" component={LoggedIn} />
          ) : (
            <Route path="/" component={LoggedOut} />
          )}
        </div>
      </AppContext.Provider>
    </ConfigProvider>
  );
};
export default App;
